import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Grid, Avatar, Divider } from "@mui/material";
import { Color } from "../../../assets/color";
import { api_urls } from "../../../utils/api-urls";

const Profile = () => {
    const { superadminAdminPartnerDetails } = useSelector((state) => state?.authReducer);
    const data = superadminAdminPartnerDetails || {};
    const role = data?.role || "Admin";

    const renderField = (label, value) => (
        <Grid item xs={12} sm={6} md={4}>
            <Typography sx={{ fontSize: 13, color: "#909296ff", fontWeight: 500 }}>{label}</Typography>
            <Typography sx={{ fontSize: 15, fontWeight: 500, color: "#111827" }}>{value || "—"}</Typography>
        </Grid>
    );

    const Section = ({ title, children }) => (
        <Grid sx={{ borderRadius: 1.5, p: 3, mb: 3, background: "#fff", boxShadow: "0 4px 4px rgba(0,0,0,0.06)" }}>
            <Typography sx={{ mb: 2, color: Color.primary || "#2563eb", fontWeight: 700, fontSize: 17 }}>{title}</Typography>
            {children}
        </Grid>
    );

    return (
        <>
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 3, mb: 4 }}>
                <Avatar src={api_urls + data?.profile_picture} alt={data?.admin_name || data?.partner_name} sx={{ width: 90, height: 90, border: "4px solid #2563eb" }} />
                <Box>
                    <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#111827" }}>
                        {role === "Admin" ? data?.admin_name || "Admin Name" : data?.partner_name || "Partner Name"}
                    </Typography>
                    <Typography sx={{ fontSize: 15, color: "#4b5563" }}>{data?.company_name || "Company Name"}</Typography>
                    <Typography sx={{ fontSize: 14, color: "#6b7280" }}>{data?.email}</Typography>
                </Box>
            </Box>

            {/* Personal Info */}
            <Section title="Personal Information">
                <Grid container spacing={2}>
                    {renderField("Role", data.role)}
                    {renderField("Gender", data.gender)}
                    {renderField("Mobile Number", data.mobile_number)}
                    {renderField("Email", data.email)}
                    {renderField("State", data.state)}
                    {renderField("City", data.city)}
                    {renderField("Address 1", data.address_one)}
                    {renderField("Address 2", data.address_two)}
                    {role === "Partner" && renderField("Registration Number", data.registration_number)}
                </Grid>
            </Section>

            {/* Professional Info */}
            <Section title="Professional Information">
                <Grid container spacing={2}>
                    {renderField("Coverage Area", data.coverage_area)}
                    {renderField("Marks in IRIS Exam", data.marks_in_iris_exam)}
                    {renderField("Total Experience (Years)", data.total_experience)}
                    {renderField("Counselling Done", data.no_of_counselling_done)}
                    {renderField("Rating", data.rating)}
                    {renderField("Account Expiry", data.account_expiry_date ? new Date(data.account_expiry_date).toLocaleDateString() : "—")}
                    {renderField("Active Status", data.is_active ? "Active" : "Inactive")}
                </Grid>
            </Section>

            {/* Expertise */}
            <Section title="Expertise">
                <div dangerouslySetInnerHTML={{ __html: data?.expertise }} style={{ fontSize: 14, color: "#374151" }}></div>
            </Section>

            {/* Images & Documents */}
            <Section title="Images & Documents">
                <Grid container spacing={2}>
                    {[
                        "business_logo",
                        "report_cover_page",
                        "certificate_image",
                        "company_profile_page_one",
                        "company_profile_page_two",
                        "company_profile_page_three",
                    ].map((key) => (
                        <Grid item xs={12} sm={6} md={4} key={key}>
                            {data[key] ? (
                                <Box sx={{ borderRadius: 2, overflow: "hidden", border: "1px solid #e5e7eb", background: "#fff" }}>
                                    <img src={api_urls + data[key]} alt={key} style={{ width: "100%", height: 160, objectFit: "contain" }} />
                                </Box>
                            ) : (
                                <Typography sx={{ color: "#9ca3af", fontSize: 14 }}>
                                    {key.replaceAll("_", " ")}: Not Uploaded
                                </Typography>
                            )}
                        </Grid>
                    ))}
                </Grid>
            </Section>

            {/* Account Info (Admin only) */}
            {role === "Admin" && (
                <Section title="Account Information">
                    <Grid container spacing={2}>
                        {renderField("AI Platform Fee", data.ai_charges_platform_fee)}
                        {renderField("Admin Royalty", data.admin_royalty)}
                        {renderField("Partner Commission", data.partner_commission)}
                        {renderField("Community Member", data.is_community_member ? "Yes" : "No")}
                    </Grid>
                </Section>
            )}

            {/* Partner Account Info (if you ever extend later) */}
            {role === "Partner" && (
                <Section title="Account Information">
                    <Grid container spacing={2}>
                        {renderField("Report Wallet Balance", data.report_wallet_balance)}
                        {renderField("Community Member", data.is_community_member ? "Yes" : "No")}
                    </Grid>
                </Section>
            )}

            <Divider sx={{ my: 4 }} />
            <Typography sx={{ fontSize: 12, color: "#9ca3af", textAlign: "center" }}>
                Last Updated: {data.updatedAt ? new Date(data.updatedAt).toLocaleString() : "—"}
            </Typography>
        </>
    );
};

export default Profile;